import React, { useState, useEffect } from "react";
import { HealthPolicyTermsItems, ITQChoices } from "../../../libs";
import { Button } from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import { DateFieldIcon } from "../../../libs/SVGIcons";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import axios from "../../../axios";
import AppConfig from "../../../constants/AppConfig";
import moment from "moment";
import { TextField, InputAdornment } from "@material-ui/core";

export const PricesCalculatorElement = ({
  handleAppError,
  setLoading,
  isDiscountedPricesPermitted,
  lang,
  isPublic = false,
}) => {
  const [state, setState] = useState({
    insurancePrices: [],
    yearscount: 1,
    date: null,
    startDate: null,
    ratio: null,
  });
  useEffect(() => {
    getInsuranceCompanies();
    return () => {};
  }, []);
  const getPrices = async () => {
    console.log("getting prices ...");
    try {
      if (!state.date || !state.yearscount || !state.startDate) {
        return;
      }
      setLoading(true);
      const params = {
        birthdate: moment(state.date).format("YYYY-MM-DD"),
        yearscount: state.yearscount,
      };
      if (state.startDate) {
        params.startdate = moment(state.startDate).format("YYYY-MM-DD");
      }
      if (state.ratio) {
        params.ratio = state.ratio;
      }
      const response = await axios.get(
        "insurance-prices/calculate-health-insurance-price",
        {
          params: params,
        }
      );
      setState({
        ...state,
        insurancePrices: response.data.data,
      });
      setLoading(false);
    } catch (error) {
      handleAppError(error);
    }
  };
  const getInsuranceCompanies = async () => {
    try {
      console.log("getting insurance companies for calculator ...");
      let apiSlug = "get-for-dropdown";
      if (isPublic) {
        apiSlug = "get-for-public-calculator";
      }
      const response = await axios.get("insurance-companies/" + apiSlug),
        insuranceCompanies = response.data.data,
        result = [];
      insuranceCompanies.forEach((insuranceCompany) => {
        if (insuranceCompany.active) {
          insuranceCompany.price = "-";
          insuranceCompany.discountedprice = "-";
          insuranceCompany.company = insuranceCompany.name;
          if (insuranceCompany.health) {
            result.push(insuranceCompany);
          }
        }
      });
      setState({
        ...state,
        insurancePrices: result,
      });
    } catch (error) {
      handleAppError(error);
    }
  };
  const containerStyle = {
    width: isPublic ? "100%" : "59%",
    height: "100%",
    backgroundColor: "white",
    paddingLeft: "30px",
    paddingRight: "30px",
  };
  if (isPublic) {
    containerStyle.borderRadius = "15px";
  }
  if (lang === "ar") {
    containerStyle.marginRight = "1%";
  } else {
    containerStyle.marginLeft = "1%";
  }
  return (
    <div
      className="col-4 db-element orders-statistics-element "
      style={containerStyle}
    >
      <div style={{ marginTop: "33px" }}>
        <h2
          style={
            isPublic
              ? { fontSize: "1.25rem", textAlign: "center" }
              : { fontSize: "1.25rem" }
          }
          className="inter inter-bold"
        >
          {!isPublic
            ? window.sys_app_translate("Insurance Calculator", lang)
            : window.sys_app_translate(
                "Insurance Calculator حاسبة التأمينات",
                lang
              )}
        </h2>
      </div>
      <div
        className="insurance-calculator-inputs"
        style={{ marginTop: "32px" }}
      >
        <div className="date-1">
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              autoOk
              variant="inline"
              onChange={(date) => {
                setState({
                  ...state,
                  date: date,
                });
              }}
              defaultValue={new Date()}
              value={state.date}
              inputVariant="outlined"
              format="dd.MM.yyyy"
              className="itqan-date-field"
              inputProps={{
                placeholder: window.sys_app_translate("Birth Date", lang),
              }}
              label={window.sys_app_translate("Birth Date", lang)}
              InputAdornmentProps={{ position: "end" }}
              size="small"
              keyboardIcon={<DateFieldIcon />}
            />
          </MuiPickersUtilsProvider>
        </div>
        <div className="date-2">
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              autoOk
              variant="inline"
              onChange={(date) => {
                setState({
                  ...state,
                  startDate: date,
                });
              }}
              defaultValue={new Date()}
              value={state.startDate}
              inputVariant="outlined"
              format="dd.MM.yyyy"
              className="itqan-date-field"
              inputProps={{
                placeholder: window.sys_app_translate("Start Date", lang),
              }}
              label={window.sys_app_translate("Start Date", lang)}
              InputAdornmentProps={{ position: "end" }}
              keyboardIcon={<DateFieldIcon />}
              size="small"
            />
          </MuiPickersUtilsProvider>
        </div>
        <div style={{ width: "5rem", display: "flex", alignItems: "center" }}>
          <TextField
            className="itqan-text-field"
            label={window.sys_app_translate("Ratio", lang)}
            variant="outlined"
            type="number"
            onChange={(e) => {
              setState({
                ...state,
                ratio: e.target.value,
              });
            }}
            size="small"
            InputProps={{
              inputProps: { min: 0, max: 100, step: ".01" },
              endAdornment: (
                <InputAdornment position="end">
                  <span>{"%"}</span>
                </InputAdornment>
              ),
            }}
          />
        </div>
        <ITQChoices
          lang={lang}
          activeItemId={state.yearscount}
          items={HealthPolicyTermsItems}
          onItemClick={(text) => {
            switch (text) {
              case "1 Year":
                setState({
                  ...state,
                  yearscount: 1,
                });
                break;
              case "2 Year":
                setState({
                  ...state,
                  yearscount: 2,
                });
                break;
              case "3 Year":
                setState({
                  ...state,
                  yearscount: 3,
                });
                break;
            }
            return true;
          }}
        />

        <Button
          variant="contained"
          style={{ display: "inline" }}
          type="submit"
          className="inter inter-semi-bold itqan-form-button-2"
          onClick={() => {
            getPrices();
          }}
        >
          {window.sys_app_translate("Calculate", lang)}
        </Button>
      </div>
      <table
        className="table prices-table"
        style={{ paddingLeft: "25px", marginTop: "29px" }}
      >
        <thead>
          <tr>
            <th
              className="inter-semi-bold"
              style={{ width: "335px", textAlign: "center" }}
            >
              {window.sys_app_translate("Company", lang)}
            </th>
            <th className="inter-semi-bold">
              {window.sys_app_translate(
                isDiscountedPricesPermitted ? "Before Discount" : "Price",
                lang
              )}
            </th>
            {isDiscountedPricesPermitted && (
              <th className="inter-semi-bold">
                {window.sys_app_translate("After Discount", lang)}
              </th>
            )}
          </tr>
        </thead>
      </table>
      <div className="prices-table-container" style={{ maxHeight: "52%" }}>
        {state.insurancePrices && (
          <table className="table prices-table">
            <tbody style={{ overflowX: "scroll" }}>
              {state.insurancePrices.map((priceRecord, index) => {
                return (
                  <tr key={"priceR" + index}>
                    <td
                      className="inter-semi-bold"
                      style={{ width: "335px", textAlign: "left" }}
                    >
                      {priceRecord.companylogo && (
                        <img
                          src={AppConfig.storagePath + priceRecord.companylogo}
                          style={{
                            height: "40px",
                            marginLeft: "15px",
                            marginRight: "16px",
                          }}
                        />
                      )}
                      {/* {priceRecord.company} */}
                    </td>
                    <td className="inter-semi-bold">{priceRecord.price}</td>
                    {isDiscountedPricesPermitted && (
                      <td className="inter-semi-bold">
                        {priceRecord.discountedprice}
                      </td>
                    )}
                  </tr>
                );
              })}
              {state.insurancePrices.length === 0 && (
                <tr>
                  <td colSpan="100">
                    <span style={{ fontSize: "1rem" }}>
                      {window.sys_app_translate("No prices found!", lang)}
                    </span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};
